import { writable } from 'svelte/store';

export const accessToken = writable(undefined);
export const event = writable(null);
export const session = writable(null);
export const attendees = writable({});
export const syncClient = writable(null);
export const syncChannels = writable({});
export const participants = writable([]);
export const layout = writable('gap');
export const banners = writable([]);
export const backgrounds = writable([]);
export const overlays = writable([]);
export const clips = writable([]);
export const clipTokens = writable({});
export const banner = writable(null);
export const background = writable(null);
export const overlay = writable(null);
export const clip = writable(null);
export const highlight = writable(null);
export const participantCount = writable(0);
export const room = writable(null);
export const trackPublications = writable({});
export const broadcasting = writable(false);
export const livestreamStatus = writable('idle');
